import React, { Component } from "react"
import Header from "../components/header"
import Step from "../components/step"
import "../pages/mystyles.scss"
import Helmet from "react-helmet"
import Player from "../components/videoplayer"
import LearnMore from "../components/learnmore"
import { useStaticQuery, Link, graphql } from "gatsby"

export default ({ data }) => {
  return (
    <div className="container">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{data.learningItem.title} - Spark Camera</title>
        <meta
          name="description"
          content={
            "Learn how to make great videos on just your iPhone. " +
            data.learningItem.title +
            "with Spark Camera"
          }
        />

        <script src="https://cdn.jsdelivr.net/npm/hls.js@0.8.2"></script>
      </Helmet>
      <div className="section">
        <Header text={data.learningItem.title} />

        <div className="columns is-gapless is-centered reverse-row-order">
          <div className="column has-text-centered">
            <div className="is-centered">
              <Player videoURL={data.learningItem.videoURL} />
            </div>
          </div>

          {data.learningItem.steps.length > 0 && (
            <div className="column is-three-fifths">
              <div className="steps-container">
                {data.learningItem.steps.map((value, index) => {
                  return <Step key={index} numeral={index + 1} text={value} />
                })}
              </div>

              <br />
              <br />
              <LearnMore />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
  query($slug: String) {
    learningItem(slug: { eq: $slug }) {
      slug
      steps
      title
      videoURL
    }
  }
`
